import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  IconButton,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CommonButton from "../../../components/CommonButton/CommonButton";
import { DialogProps } from "./types";

interface UploadVideoDialogProps extends DialogProps {
  selectedFile: File | null;
  onFileSelect: (event: React.ChangeEvent<HTMLInputElement>) => void;
  selectedAppType: string;
  onAppTypeChange: (value: string) => void;
}

const UploadVideoDialog: React.FC<UploadVideoDialogProps> = ({
  open,
  onClose,
  onConfirm,
  loading,
  error,
  selectedFile,
  onFileSelect,
  selectedAppType,
  onAppTypeChange
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => !loading && onClose()}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography sx={{ fontWeight: 600, fontSize: "18px" }}>
            Upload Video
          </Typography>
          <IconButton onClick={() => !loading && onClose()} disabled={loading}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        {error && (
          <div style={{ marginTop: "5px", marginBottom: "16px" }}>
            <Alert severity="error">{error}</Alert>
          </div>
        )}
        <Box
          sx={{
            mt: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2
          }}
        >
          <FormControl fullWidth>
            <InputLabel>App ID</InputLabel>
            <Select
              value={selectedAppType}
              onChange={(e) => onAppTypeChange(e.target.value)}
              label="App ID"
              disabled={loading}
            >
              <MenuItem value="PaymentAppRewardle">PaymentAppRewardle</MenuItem>
              <MenuItem value="TabletAppRewardle">TabletAppRewardle</MenuItem>
              <MenuItem value="TabletAppMobileRewardle">
                TabletAppMobileRewardle
              </MenuItem>
            </Select>
          </FormControl>
          <Box
            sx={{
              border: "2px dashed #bdbdbd",
              borderRadius: "12px",
              width: "100%",
              minHeight: "120px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#fcfcfc"
            }}
          >
            <input
              type="file"
              accept="video/*"
              onChange={onFileSelect}
              style={{ display: "none" }}
              id="video-upload"
            />
            <label
              htmlFor="video-upload"
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center"
              }}
            >
              <CommonButton
                component="span"
                variant="contained"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "row"
                }}
              >
                <CloudUploadIcon sx={{ mr: 1 }} />
                CHOOSE VIDEO FILE
              </CommonButton>
            </label>
          </Box>
          {selectedFile && (
            <Typography variant="body2" color="textSecondary">
              Selected file: {selectedFile.name}
            </Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <CommonButton onClick={() => !loading && onClose()} disabled={loading}>
          Cancel
        </CommonButton>
        <CommonButton
          onClick={onConfirm}
          disabled={loading || !selectedFile || !selectedAppType}
          isLoading={loading}
        >
          {loading ? "Uploading..." : "Add"}
        </CommonButton>
      </DialogActions>
    </Dialog>
  );
};

export default UploadVideoDialog;
